// Reads "I want to fund a campaign for Adam Brandon for $7k" into
// { name: "Adam Brandon", amount: 7000 }. Either can be missing.
const UNIT = { k: 1e3, thousand: 1e3, grand: 1e3, m: 1e6, million: 1e6 };
const WITH_DOLLAR = /\$\s*(\d[\d,]*(?:\.\d+)?)\s*(k|m|thousand|grand|million)?\b/i;
const WITH_WORD = /\b(\d[\d,]*(?:\.\d+)?)\s*(k|m|thousand|grand|million|dollars|usd|bucks)\b/i;
const FILLER = /\b(campaign|clipping|clippers?|please)\b/gi;

const titleCase = (s) => (s === s.toLowerCase() ? s.replace(/(^|\s)(\S)/g, (m, a, b) => a + b.toUpperCase()) : s);

export function parseFundPrompt(text) {
  let rest = String(text || "").trim();
  let amount = 0;
  const m = rest.match(WITH_DOLLAR) || rest.match(WITH_WORD);
  if (m) {
    amount = Math.round(parseFloat(m[1].replace(/,/g, "")) * (UNIT[(m[2] || "").toLowerCase()] || 1) * 100) / 100;
    rest = rest.replace(m[0], " ");
  }
  rest = rest.replace(/\s+/g, " ").trim();
  const n = rest.match(/\bfor\s+(.+?)(?:\s+(?:for|with|at|worth|of)\b.*)?$/i)
    || rest.match(/\bfund\s+(?:a\s+)?(.+?)(?:\s+(?:for|with|at|worth|of)\b.*)?$/i);
  // No "for" or "fund": a bare "adam brandon 7k".
  let name = n ? n[1] : (/\b(i|want|to|fund)\b/i.test(rest) ? "" : rest);
  name = name.replace(FILLER, " ").replace(/^\s*(a|an|the)\s+/i, "").replace(/[@.,!?]/g, " ").replace(/\s+/g, " ").trim();
  if (/^(a|an|the|for|me)$/i.test(name) || name.split(" ").length > 5) name = "";
  return { name: titleCase(name), amount };
}
